<template>
	<div>
		<app-inbox-loading v-if="isDataLoading" />
		<div v-else>
			<b-row v-if="false">
				<b-col>
					<b-button class="btn-close-page float-right mb-2" @click="$emit('closePage')" v-b-tooltip.hover
						title="Close"><b-icon-x /></b-button>
					<b-button class="btn-close-page float-right mb-2 mr-2" @click="$emit('approvalFlow')"
						v-b-tooltip.hover title="Approval History"><b-icon icon="clock-history" /></b-button>
				</b-col>
			</b-row>
			<b-card header="Purchase Order" class="mb-3">
				<b-row>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Purchase Order Number"
							:model="model.purchaseOrderNumber" />
						<app-input-combobox-autocomplete :options="purchaseRequests"
							optionsLabel="purchaseRequestNumber" optionsKey="id" label-cols-lg="12"
							label="Purchase Request Number" id="fieldset-purchase-request" size="sm"
							:model.sync="model.purchaseRequestId"
							:selected="model.purchaseRequest != null ? model.purchaseRequest.purchaseRequestNumber : ''"
							@input="getPurchaseRequests" @change="updatePurchaseRequest" :isRequired="true"
							:isEditable="false" :isSelectMethodExists="true" @onSelectMethod="updatePurchaseRequest"
							:state="validateState('purchaseRequestNumber')"
							:errorMessage="getErrorMessage(errorMessage.purchaseRequestNumber, 'purchaseRequestNumber')" />
						<app-input-datepicker id="fieldset-purchase-order-date" label-cols-lg="12"
							label="Purchase Order Date" size="sm" :model.sync="model.purchaseOrderDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							:isRequired="true" @change="updateData" :isEditable="false"
							:state="validateState('purchaseOrderDate')"
							:errorMessage="getErrorMessage(errorMessage.purchaseOrderDate, 'purchaseOrderDate')" />
						<app-input-datepicker id="fieldset-delivery-date-request" label-cols-lg="12"
							label="Delivery Date Request" size="sm" :model.sync="model.deliveryDateRequest"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							:isRequired="true" @change="updateData" :isEditable="false"
							:state="validateState('deliveryDateRequest')"
							:errorMessage="getErrorMessage(errorMessage.deliveryDateRequest, 'deliveryDateRequest')" />
						<app-input-textarea id="fieldset-purpose" label-cols-lg="12" label="Purpose"
							label-for="input-purpose" size="sm" :model.sync="model.purpose" @change="updateData"
							:isEditable="false" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark"
							label-for="input-remark" size="sm" :model.sync="model.remark" @change="updateData"
							:isEditable="false" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id"
							label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm"
							:model.sync="model.vendorId" :selected="model.vendor != null ? model.vendor.code : ''"
							@input="getVendors" @change="updateData" :isRequired="true" :isEditable="false"
							:isSelectMethodExists="true" @onSelectMethod="updateVendor"
							:state="validateState('vendorId')"
							:errorMessage="getErrorMessage(errorMessage.vendorId, 'vendorId')" />
						<app-input-textbox label-cols-lg="12" size="sm" label="Contact Person"
							:model="(model.vendor != null) ? model.vendor.contactPerson : null" :isEditable="false" />
						<app-input-textbox id="fieldset-quotation-number" label-cols-lg="12" label="Quotation Number"
							label-for="input-quotation-number" size="sm" :model.sync="model.quotationNumber"
							@change="updateData" :isEditable="false" type="number" />
						<app-input-datepicker id="fieldset-quotation-date" label-cols-lg="12" label="Quotation Date"
							size="sm" :model.sync="model.quotationDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							@change="updateData" :isEditable="false" />

						<app-input-textbox id="fieldset-ppm" label-cols-lg="12" label="Ppn" label-for="input-ppn"
							size="sm" :model.sync="model.ppn" @change="updateData" :isEditable="false" type="number" />
					</b-col>
				</b-row>
			</b-card>

			<app-table-input title="Purchase Order Detail" :bordered="true" :items="purchaseOrderDetails"
				:fields="fieldsPurchaseOrderDetail" :busy="isDataLoading" :sort-by.sync="sortByPurchaseOrderDetail"
				:sort-desc.sync="sortDescPurchaseOrderDetail" small responsive
				@editButtonMethod="editRowDataPurchaseOrderDetail"
				@deleteButtonMethod="deleteRowDataPurchaseOrderDetail"
				@showPopupAddMethod="addDataPurchaseOrderDetail()"
				@showPopupUploadMethod="showPopupUploadPurchaseOrderDetail()"
				@downloadMethod="downloadPurchaseOrderDetail()"
				@addFromClipboardMethod="addFromClipboardPurchaseOrderDetail()"
				@replaceFromClipboardMethod="replaceFromClipboardPurchaseOrderDetail()" :showActionButton="false"
				:showDeleteButton="false" :showAddButton="false" :showAddFromClipboardButton="false"
				:showReplaceFromClipboardButton="false" :showUploadButton="false" :showDownloadButton="false"
				:isDownloadBusy="isDownloadPurchaseOrderDetail">

				<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPurchaseOrderDetailFilter = !isShowPurchaseOrderDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->

				<template #top-row v-if="isShowPurchaseOrderDetailFilter">
					<b-th></b-th>
					<b-th stacked-heading="Part Code">
						<v-select id="input-purchase-order-detail-part-table" append-to-body label="partNumber"
							:options="parts" :value="filterPurchaseOrderDetail.partId" :reduce="item => item.id"
							v-model="filterPurchaseOrderDetail.partId" @search="getParts" :filterable="true"></v-select>
					</b-th>
					<b-th stacked-heading="Qty PO">
						<b-form-input id="input-purchase-order-detail-qty-po-table"
							v-model="filterPurchaseOrderDetail.qtyPo" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Price (Rp/Unit)">
						<b-form-input id="input-purchase-order-detail-price-unit-table"
							v-model="filterPurchaseOrderDetail.priceUnit" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Subtotal (Rp)">
						<b-form-input id="input-purchase-order-detail-subtotal-table"
							v-model="filterPurchaseOrderDetail.subtotal" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Ppn">
						<b-form-input id="input-purchase-order-detail-price-ppn-table"
							v-model="filterPurchaseOrderDetail.pricePpn" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Amount">
						<b-form-input id="input-purchase-order-detail-amount-table"
							v-model="filterPurchaseOrderDetail.amount" size="sm"></b-form-input>
					</b-th>

					<b-th></b-th>
				</template>

				<template v-slot:cell(no)="row">
					{{ ((row.index + 1) + (purchaseOrderDetailPageSize * (currentPurchaseOrderDetailPage - 1))) }}
				</template>

				<template v-slot:table-busys>
					<div class="text-center my-2">
						<b-spinner class="align-middle text-primary"></b-spinner>
						<strong class="ml-2">Loading...</strong>
					</div>
				</template>

				<template v-slot:cell(part)="row">
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
						:id="'input-purchase-order-detail-part-' + row.index" label-cols-lg="12" label="Part Code"
						size="sm" :model.sync="row.item.partId" :state="validateState('partId')"
						:errorMessage="getErrorMessage(errorMessage.partId, 'partId')"
						@change="saveInputPurchaseOrderDetail(row.item)"
						:selected="row.item.part != null ? row.item.part.partNumber : ''" @input="getParts"
						:loading="isPartComboLoading" :isEditable="false" :nolabel="true" />
				</template>
				<template v-slot:cell(partName)="row">
					<app-input-textbox label-cols-lg="12" size="sm" label="Part Name"
						:model="(row.item.part != null) ? row.item.part.partName : null" :isEditable="false"
						:nolabel="true" />
				</template>
				<template v-slot:cell(qtyPo)="row">
					<app-input-textbox :id="'input-purchase-order-detail-qty-po-' + row.index" label-cols-lg="12"
						label="Qty PO" size="sm" :model.sync="row.item.qtyPo" :state="validateState('qtyPo')"
						:errorMessage="getErrorMessage(errorMessage.qtyPo, 'qtyPo')"
						@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true"
						:thousandSeparator="true" />
				</template>
				<template v-slot:cell(qtyOutstanding)="row">
					<app-input-textbox :id="'input-purchase-order-detail-qty-outstanding-' + row.index"
						label-cols-lg="12" label="Qty Outstanding" size="sm" :model.sync="row.item.qtyOutstanding"
						:state="validateState('qtyOutstanding')"
						:errorMessage="getErrorMessage(errorMessage.qtyOutstanding, 'qtyOutstanding')"
						@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true"
						:thousandSeparator="true" />
				</template>
				<template v-slot:cell(uomPo)="row">
					<app-input-textbox label-cols-lg="12" size="sm" label="Uom Po"
						:model="(row.item.part != null) ? (row.item.part.uomPo != null) ? row.item.part.uomPoCode : null : null"
						:nolabel="true" :isEditable="false" />
				</template>
				<template v-slot:cell(priceUnit)="row">
					<app-input-textbox :id="'input-purchase-order-detail-price-unit-' + row.index" label-cols-lg="12"
						label="Price (Rp/Unit)" size="sm" :thousandSeparator="true" :model.sync="row.item.priceUnit"
						:state="validateState('priceUnit')"
						:errorMessage="getErrorMessage(errorMessage.priceUnit, 'priceUnit')"
						@change="recalculateSummary(row.item)" :isEditable="false" :nolabel="true" />
				</template>
				<template v-slot:cell(subtotal)="row">
					<app-input-textbox :id="'input-purchase-order-detail-subtotal-' + row.index" label-cols-lg="12"
						label="Subtotal (Rp)" size="sm" :thousandSeparator="true" :model.sync="row.item.subtotal"
						:state="validateState('subtotal')"
						:errorMessage="getErrorMessage(errorMessage.subtotal, 'subtotal')"
						@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true" />
				</template>
				<template v-slot:cell(pricePpn)="row">
					<app-input-textbox :id="'input-purchase-order-detail-price-ppn-' + row.index" label-cols-lg="12"
						label="Ppn" size="sm" :thousandSeparator="true" :model.sync="row.item.pricePpn"
						:state="validateState('pricePpn')"
						:errorMessage="getErrorMessage(errorMessage.pricePpn, 'pricePpn')"
						@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true" />
				</template>
				<template v-slot:cell(amount)="row">
					<app-input-textbox :id="'input-purchase-order-detail-amount-' + row.index" label-cols-lg="12"
						label="Amount" size="sm" :thousandSeparator="true" :model.sync="row.item.amount"
						:state="validateState('amount')" :errorMessage="getErrorMessage(errorMessage.amount, 'amount')"
						@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true" />
				</template>


				<template v-slot:form-add-detail>
					<PurchaseOrderDetailInput :model="modelPurchaseOrderDetail"
						:openPopup="isShowPopupPurchaseOrderDetail" @resetMethod="resetModal"
						@addButtonMethod="addRowDataPurchaseOrderDetail" />
				</template>
				<template v-slot:upload-detail>
					<PurchaseOrderDetailUpload :openPopup="isShowPopupUploadPurchaseOrderDetail"
						@resetMethod="resetModal" @uploadButtonMethod="uploadDataPurchaseOrderDetail"
						:parentId="modelId" />
				</template>
				<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPurchaseOrderDetailPage"
				:total-rows="totalPurchaseOrderDetailRow"
				:per-page="purchaseOrderDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
			</app-table-input>

			<b-card header="Summary" class="mb-3">
				<b-row>
					<b-col cols="6" lg="3">
						<p class="mt-2">Total Qty</p>
						<p class="mt-2">Total Amount</p>
					</b-col>
					<b-col cols="6" lg="3">
						<app-input-textbox :id="'input-purchase-order-total-qty'" label="Total Amount" size="sm"
							:thousandSeparator="true" :model.sync="model.totalQty" :state="validateState('totalQty')"
							:errorMessage="getErrorMessage(errorMessage.totalAmount, 'totalQty')" :isEditable="false"
							:nolabel="true" />
						<app-input-textbox :id="'input-purchase-order-total-amount'" label="Total Amount" size="sm"
							:thousandSeparator="true" :model.sync="model.totalAmount"
							:state="validateState('totalAmount')"
							:errorMessage="getErrorMessage(errorMessage.totalAmount, 'totalAmount')" :isEditable="false"
							:nolabel="true" />
					</b-col>
				</b-row>
			</b-card>

			<app-table-input 
		title="PO Attachment"
		:bordered="true" :items="purchaseOrderAttachments" 
		:fields="fieldsPurchaseOrderAttachment" 
		:busy="isDataLoading" 
		:sort-by.sync="sortByPurchaseOrderAttachment" 
		:sort-desc.sync="sortDescPurchaseOrderAttachment" small responsive	
		@editButtonMethod="editRowDataPurchaseOrderAttachment"	
		@deleteButtonMethod="deleteRowDataPurchaseOrderAttachment"	
		@showPopupAddMethod="addDataPurchaseOrderAttachment()"	
		@showPopupUploadMethod="showPopupUploadPurchaseOrderAttachment()"
		@downloadMethod="downloadPurchaseOrderAttachment()"
		@addFromClipboardMethod="addFromClipboardPurchaseOrderAttachment()"
		@replaceFromClipboardMethod="replaceFromClipboardPurchaseOrderAttachment()"
		:showActionButton="false"
		:showDeleteButton="false"
		:showAddButton="false"
		:showAddFromClipboardButton="false"	
		:showReplaceFromClipboardButton="false"	
		:showUploadButton="false"	
		:showDownloadButton="false"	
		:isDownloadBusy="isDownloadPurchaseOrderAttachment"
	>
							
		<!-- <template v-slot:head(actions)>
			<b-button @click="isShowPurchaseOrderAttachmentFilter = !isShowPurchaseOrderAttachmentFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
		</template> -->
							
		<template #top-row v-if="isShowPurchaseOrderAttachmentFilter">
			<b-th></b-th>
			<b-th stacked-heading="Attachment">
			</b-th>
			<b-th stacked-heading="Remarks">
				<b-form-input id="input-table-purchase-order-attachment-remarks-table" v-model="filterPurchaseOrderAttachment.remarks" size="sm"></b-form-input>
			</b-th>

			<b-th></b-th>
		</template>
							
		<template v-slot:cell(no)="row">
			{{ ((row.index + 1) + ( purchaseOrderAttachmentPageSize * (currentPurchaseOrderAttachmentPage - 1))) }}
		</template>
							
		<template v-slot:table-busys>
			<div class="text-center my-2">
				<b-spinner class="align-middle text-primary"></b-spinner>
				<strong class="ml-2">Loading...</strong>
			</div>
		</template>
							
		<template v-slot:cell(poAttachment)="row">
			<app-input-fileupload :id="'input-table-purchase-order-attachment-' + row.index" label-cols-lg="12" label="Attachment" size="sm" :model.sync="poAttachments[row.item.id]" :currentModel="row.item.poAttachment" @change="saveInputPurchaseOrderAttachment(row.item)" :isUpdatable ="true" :isEditable="false"  :nolabel="true" />
		</template>
		<template v-slot:cell(remarks)="row">
			<app-input-textarea :id="'input-table-purchase-order-attachment-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputPurchaseOrderAttachment(row.item)" :isUpdatable ="false" :isEditable="false" :nolabel="true" />
		</template>

							
		<!-- <template v-slot:form-add-detail>
			<PurchaseOrderAttachmentInput 
				:model="modelPurchaseOrderAttachment"
				:openPopup="isShowPopupPurchaseOrderAttachment"
				@resetMethod="resetModal"
				@addButtonMethod="addRowDataPurchaseOrderAttachment"/>
		</template>
		<template v-slot:upload-detail>
				<PurchaseOrderAttachmentUpload
				:openPopup="isShowPopupUploadPurchaseOrderAttachment"
				@resetMethod="resetModal"
				@uploadButtonMethod="uploadDataPurchaseOrderAttachment"
				:parentId="modelId"
				/>
		</template> -->
		<!-- <template v-slot:table-paging>
			<b-pagination
			class="float-right btn-paging"
			v-model="currentPurchaseOrderAttachmentPage"
			:total-rows="totalPurchaseOrderAttachmentRow"
			:per-page="purchaseOrderAttachmentPageSize"
			aria-controls="my-table"
			></b-pagination>
		</template> -->
			</app-table-input>


			<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal"
				label="Print Purchase Order" />
			<b-overlay :show="isBusy" no-wrap></b-overlay>
			<Portal to="app-inbox-button">
				<b-button size="sm" class="btn btn-outline-success float-right" @click="printPdf"
					v-if="this.model.statusId == 'REJECTED' ? false : true"><b-icon-printer class="mr-1" />PrintPO</b-button>
				<app-approval-button @approveMethod="editDraftAction" :showApproveButton="true"
					approveButtonTitle="Revisi" @rejectMethod="cancelAction" :showRejectButton="true"
					rejectButtonTitle="Cancel Request" :showRevisionButton="false" />
			</Portal>
		</div>
	</div>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderList from '@/models/PurchaseOrder/PurchaseOrderList';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import PopupPDF from '@/components/PopupPDF';

import AppInputTextarea from '@/components/AppInputTextarea';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseRequest from '@/models/PurchaseRequest/PurchaseRequest';
import PurchaseRequestFilter from '@/filters/PurchaseRequest/PurchaseRequestFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PurchaseOrderDetailInput from '@/views/PurchaseOrder/PurchaseOrderDetailInput';
import PurchaseOrderDetailUpload from '@/views/PurchaseOrder/PurchaseOrderDetailUpload';
import PartClassification from '@/models/PartClassification/PartClassification';

import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import AppApprovalButton from '@/components/AppApprovalButton';
import PurchaseOrderAttachment from '@/models/PurchaseOrder/PurchaseOrderAttachment';
import PurchaseOrderAttachmentFilter from '@/filters/PurchaseOrder/PurchaseOrderAttachmentFilter';
import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props:
	{
		selectedModelId: {
			default: "",
			type: String
		},
		selectedModel: {
			default: null,
			type: Object
		},
		successAction: {},
		inboxType: {
			default: "",
			type: String
		}
	}
	,
	components: {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		PurchaseOrderDetailInput,
		PurchaseOrderDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail,
		PopupRouterView,
		AppApprovalButton,
		AppInputTextarea,

		PopupRouterViewApprovalDetail,
		PopupRouterViewDetail,
		PopupRouterView,
		AppApprovalButton,
		PopupPDF,
		AppInputFileupload,
	},
	mixins: [validationMixin],
	validations: {
		model: {
		}
	},

	data() {
		return {
			errorMessage: {
			},

			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			isShowDataDetailFilter: false,
			isDownloadDataDetail: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			backroute: '',
			approvalConfiguration: {},
			fieldsPurchaseOrderDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "part": { "class": "th-part first-child", "label": "Part Code", key: 'part', sortable: true } },
				{ "partName": { "class": "th-part-name", "label": "Part Name", key: 'partName', sortable: true } },
				{ "qtyPo": { "class": "th-qty-po last-child", "label": "Qty PO", key: 'qtyPo', sortable: true } },
				{ "uomPo": { "class": "th-uomPo d-stack-none", "label": "Uom Po", key: 'uomPo', sortable: true } },
				{ "priceUnit": { "class": "th-price-unit d-stack-none", "label": "Price (Rp/Unit)", key: 'priceUnit', sortable: true } },
				{ "subtotal": { "class": "th-subtotal d-stack-none", "label": "Subtotal (Rp)", key: 'subtotal', sortable: true } },
				{ "pricePpn": { "class": "th-price-ppn d-stack-none", "label": "Ppn", key: 'pricePpn', sortable: true } },
				{ "amount": { "class": "th-amount d-stack-none", "label": "Amount", key: 'amount', sortable: true } },
				{ "qtyOutstanding": { "class": "th-qty-outstanding d-stack-none", "label": "Qty Outstanding", key: 'qtyOutstanding', sortable: true } },
				//{ "percentagePpn": { "class": "th-percentage-ppn d-stack-none", "label": "Percentage Ppn", key: 'percentagePpn', sortable: true } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			fieldsPurchaseOrderAttachment: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"poAttachment": { "class" : "th-po-attachment first-child", "label" : "Attachment", key: 'poAttachment', sortable: false}}, 
				{"remarks": { "class" : "th-remarks", "label" : "Remarks", key: 'remarks', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelPurchaseOrderAttachment : {},
			isShowPopupPurchaseOrderAttachment : false,
			isShowPopupUploadPurchaseOrderAttachment : false,
			filterPurchaseOrderAttachment : null,
			currentPurchaseOrderAttachmentPage : 1,
			purchaseOrderAttachmentPageSize: 10,
			sortByPurchaseOrderAttachment: '',
			sortDescPurchaseOrderAttachment: '',
			sortingByPurchaseOrderAttachment: [],
			purchaseOrderAttachments : [],
			purchaseOrderAttachmentId : '',
			totalPurchaseOrderAttachmentRow : 0,
			isShowPurchaseOrderAttachmentFilter: false,
			isDownloadPurchaseOrderAttachment: false,
			poAttachments: [],
			isAttachmentComboLoading: false,
			modelPurchaseOrderDetail: {},
			isShowPopupPurchaseOrderDetail: false,
			isShowPopupUploadPurchaseOrderDetail: false,
			filterPurchaseOrder: null,
			currentPurchaseOrderPage: 1,
			purchaseOrderPageSize: 10,
			sortByPurchaseOrder: '',
			sortDescPurchaseOrder: '',
			filterPurchaseOrderDetail: null,
			currentPurchaseOrderDetailPage: 1,
			purchaseOrderDetailPageSize: 10,
			sortByPurchaseOrderDetail: '',
			sortDescPurchaseOrderDetail: '',
			sortingByPurchaseOrderDetail: [],
			purchaseOrderDetails: [],
			purchaseOrderDetailId: '',
			totalPurchaseOrderDetailRow: 0,
			isShowPurchaseOrderDetailFilter: false,
			isDownloadPurchaseOrderDetail: false,
			parts: [],
			purchaseRequests: [],
			purchaseRequests: [],
			isPurchaseRequestComboLoading: false,
			vendors: [],
			vendors: [],
			isVendorComboLoading: false,
			backroute: '',
			isPurchaseRequestComboLoading: false,
			isVendorComboLoading: false,
			isPartComboLoading: false,
			isPurchaseOrderComboLoading: false,
			isShowPopupPDF: false,
			pdfUrl: '',
		}
	},
	methods: {
		getPurchaseOrderAttachments : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPurchaseOrderAttachment);
			if (this.modelId == null) return;
			filter.purchaseOrderId = this.modelId;
			//filter.draftMode = "1";
			if (this.sortByPurchaseOrderAttachment != null) {
				this.sortingByPurchaseOrderAttachment[this.sortByPurchaseOrderAttachment] = this.sortDescPurchaseOrderAttachment;
			}
			let currentPage = (this.currentPurchaseOrderAttachmentPage - 1);
			if (isAddRow) {
				let totalData = this.totalPurchaseOrderAttachmentRow + 1;
				let page = Math.ceil(totalData/this.purchaseOrderAttachmentPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.purchaseOrderAttachmentPageSize = 0;
			// disable paging end
			PurchaseOrderAttachment.getList(this, filter, this.sortingByPurchaseOrderAttachment, currentPage , this.purchaseOrderAttachmentPageSize).then(async result => {
				this.currentPurchaseOrderAttachmentPage = currentPage + 1;
				this.purchaseOrderAttachments = result.data;
				this.totalPurchaseOrderAttachmentRow = result.dataCount;
				this.poAttachments = Array();
				for(var item of result.data) {
					if (item.poAttachmentId) {
						let type = 'plain/txt';
						this.poAttachments[item.id] = new File([await fetch(item.poAttachment.downloadUrl).then(r => r.blob())], item.poAttachment.originalFilename, { type: type });
					}
				}

			}).catch(error => {});
		},
		getAttachments : async function(input) {
			let filter = new AttachmentFilter();
			if (input != undefined) {
				filter.originalFilename = input;
			}
			this.isAttachmentComboLoading = true;
			Attachment.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.attachments = result.data
				}
				this.isAttachmentComboLoading = false;
			})
			.catch(error => {});
		},
		addRowDataPurchaseOrderAttachment(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.purchaseOrderId =  this.modelId;
					PurchaseOrderAttachment.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPurchaseOrderAttachments(true);
						this.isShowPopupPurchaseOrderAttachment = false;
					})
				} else {
					model.purchaseOrderId =  this.modelId;
					PurchaseOrderAttachment.createDataDetail(this, model)
					.then(result => {
						this.getPurchaseOrderAttachments(true);
						this.isShowPopupPurchaseOrderAttachment = false;
					})
				}
			}
		},
		async editRowDataPurchaseOrderAttachment(id) {
			this.purchaseOrderAttachmentId = id;
			this.isShowPopupPurchaseOrderAttachment = true; 
		},
		async deleteRowDataPurchaseOrderAttachment(id) {
			PurchaseOrderAttachment.deleteData(this, id).then(result => { this.getPurchaseOrderAttachments(); });
		},
		async resetDataPurchaseOrderAttachment() {
			this.purchaseOrderAttachmentId = "";
			this.isShowPopupPurchaseOrderAttachment = true;
		},
		async addDataPurchaseOrderAttachment() {
			PurchaseOrderAttachment.createData(this, { purchaseOrderId: this.modelId })
			.then(result => {
				this.getPurchaseOrderAttachments(true);
			})
		},
		async addFromClipboardPurchaseOrderAttachment() {
			let remarkss = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					remarkss.push({ remarks: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderAttachment.addFromClipboard(this, remarkss).then(result => { this.getPurchaseOrderAttachments() });
			});
		},
		async replaceFromClipboardPurchaseOrderAttachment() {
			let remarkss = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					remarkss.push({ remarks: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderAttachment.replaceFromClipboard(this, remarkss).then(result => { this.getPurchaseOrderAttachments() });
			});   
		},
		showPopupUploadPurchaseOrderAttachment() {
			if(this.purchaseOrderAttachments != null && this.purchaseOrderAttachments.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PurchaseOrderAttachment akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPurchaseOrderAttachment = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPurchaseOrderAttachment = true;
			}
		},
		uploadDataPurchaseOrderAttachment(modalEvent, newDatas) {
			this.isShowPopupUploadPurchaseOrderAttachment = false; 
		},
		downloadPurchaseOrderAttachment(modalEvent) {
			this.isDownloadPurchaseOrderAttachment = true;
			this.filterPurchaseOrderAttachment.purchaseOrderId = this.modelId;
			PurchaseOrderAttachment.downloadDataDetail(this, this.filterPurchaseOrderAttachment).then(result => {
				this.isDownloadPurchaseOrderAttachment = false;
			}).catch(error => { this.isDownloadPurchaseOrderAttachment = false; })
		},
		saveInputPurchaseOrderAttachment(item) {

			let id = item.id;
			let promises = Array();
			if (this.poAttachments[id] != null) {
				let data = new FormData();
				data.append('file', this.poAttachments[id]);
				let _this = this;
				let resultValidateSize = this.ValidateFileSize(this.poAttachments[id]);
				let resultValidateFormat = this.ValidateFileFormat(this.poAttachments[id]);
				if (resultValidateSize != "" || resultValidateFormat != "") {
					let errorMessage = resultValidateFormat != "" ? resultValidateFormat : "";
					if (errorMessage != null || errorMessage != "") {
						errorMessage += "<br />";
					}

					errorMessage += resultValidateSize != "" ? resultValidateSize : "";
					this.poAttachments[id] = null;
					this.showAlert(errorMessage);
					return;
				}
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								item.poAttachmentId = response.data.id;
								item.poAttachment = response.data;
							}
						}
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			}


			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseOrderAttachment.updateData(this, item, item.id);
				}
			});
		},
		printPdf: async function () {
			try {
				this.isBusy = true;
				var result = await PurchaseOrder.PrintPoPdf(this, this.modelId);
				this.isShowPopupPDF = true;
				this.pdfUrl = result.download;
				this.isBusy = false;
			} catch {
				this.isBusy = false;
			}
		},
		updatePurchaseRequest(item) {
			const msg = this.$createElement;
			let msgNode = '';
			msgNode = msg('div', { domProps: { innerHTML: '<p>The data on the list will be reloaded, will you continue?</p>' } })
			this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(async e => {
				if (e) {
					this.isBusy = true;
					await this.setSelectedPurchaseRequest(item);
					await this.getVendors(null);
					await this.setSelectedVendor(null);
					this.isBusy = false;
				} else {
					return;
				}
			});
		},
		async updateVendor(item) {
			const msg = this.$createElement;
			let msgNode = '';
			msgNode = msg('div', { domProps: { innerHTML: '<p>The data on the list will be reloaded, will you continue?</p>' } })
			this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(async e => {
				if (e) {
					this.isBusy = true;
					await this.setSelectedVendor(item);
					this.isBusy = false;
				} else {
					return;
				}
			});
		},
		async setSelectedPurchaseRequest(item) {
			if (item == undefined || item == null) {
				this.model.purchaseOrderDate = null;
				this.model.purchaseRequestId = null;
				this.model.purchaseRequest = null;
			} else {
				this.model.purchaseRequestId = item.id;
				this.model.purchaseRequest = item;
				this.model.purchaseOrderDate = item.purchaseRequestDate;
			}
			this.$forceUpdate();
			await this.updateData();
		},
		getVendors: async function (input) {
			if (!this.model.purchaseRequestId) {
				this.vendors = [];
				return;
			}
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Vendor.getByPurchaseRequisition(this, this.model.purchaseRequestId, filter, null, 0, 10)
				.then(result => {
					this.vendors = result.data;
				})
				.catch(error => { });
		},
		async createPoDetail() {
			await PurchaseOrder.createPartPurchaseOrderDetails(this, this.modelId);
			this.getPurchaseOrderDetails(null);
		},
		async setSelectedVendor(item) {
			if (item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			await this.updateData();
			await this.createPoDetail();
		},
		getPurchaseOrder: async function (id) {
			this.isDataLoading = true;
			this.getPurchaseOrderDetails();
			this.getPurchaseOrderAttachments();

			PurchaseOrder.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				//PurchaseOrder.getApprovalConfigurationInput(this, result.approvalInstanceId).then(result => { this.approvalConfiguration = result; this.isDataLoading = false; }).catch(() => { this.isDataLoading = false; });
				this.isDataLoading = false;
			}).catch(error => { this.isDataLoading = false; });
		},
		downloadData() {
			this.isDownloadPurchaseOrder = true;
			this.filterPurchaseOrder.id = this.modelId;
			PurchaseOrder.downloadDataDetail(this, this.filterPurchaseOrder).then(result => {
				this.isDownloadPurchaseOrder = false;
			}).catch(error => { this.isDownloadPurchaseOrder = false; })
		},
		getPurchaseOrderDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPurchaseOrderDetail);
			if (this.modelId == null) return;
			filter.purchaseOrderId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByPurchaseOrderDetail != null) {
				this.sortingByPurchaseOrderDetail[this.sortByPurchaseOrderDetail] = this.sortDescPurchaseOrderDetail;
			}
			let currentPage = (this.currentPurchaseOrderDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPurchaseOrderDetailRow + 1;
				let page = Math.ceil(totalData / this.purchaseOrderDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.purchaseOrderDetailPageSize = 0;
			// disable paging end
			PurchaseOrderDetail.getList(this, filter, this.sortingByPurchaseOrderDetail, currentPage, this.purchaseOrderDetailPageSize).then(result => {
				this.currentPurchaseOrderDetailPage = currentPage + 1;
				this.purchaseOrderDetails = result.data;
				this.totalPurchaseOrderDetailRow = result.dataCount;

				this.purchaseOrderDetails.forEach(async data => {
					if (data == null || data.part == null) return;

					if (data.part.partClassificationId != null) {
						if (data.part.partClassification.code.toUpperCase() == "RM" || data.part.partClassification.code.toUpperCase() == "COMPONENT") {
							data.part.partName = data.part.partSpecification;
						} else {
							data.part.partName = data.part.partName;
						}
					} else {
						data.part.partName = "";
					}
				});
			}).catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseOrders: async function (input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			this.isPurchaseOrderComboLoading = true;
			PurchaseOrder.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseOrders = result.data
					}
					this.isPurchaseOrderComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseRequests: async function (input) {
			let filter = new PurchaseRequestFilter();
			if (input != undefined) {
				filter.purchaseRequestNumber = input;
			}
			PurchaseRequest.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseRequests = result.data
					}
				})
				.catch(error => { });
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseOrder.updateData(this, model, id);
				}
			});
		},

		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseOrder.updateData(this, model, id);
				}
			});
		},
		editDraftAction(modelEvent) {
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'purchaseordercreateinboxrequest', params: { id: id } });
			}
		},
		submitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				PurchaseOrder.submitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		approveAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to approve this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						this.isBusy = true;
						PurchaseOrder.approveApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		rejectAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to reject this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						this.isBusy = true;
						PurchaseOrder.rejectApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		reviseAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to ask for revision for this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						this.isBusy = true;
						PurchaseOrder.reviseApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		editRequestAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				PurchaseOrder.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'purchaseordercreateinboxrequest', params: { id: result.id } });
						}
					}
					this.isCreateBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		discardAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to discard this data?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						this.isBusy = true;
						PurchaseOrder.discardData(this, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				PurchaseOrder.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		cancelAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to cancel this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						this.isBusy = true;
						PurchaseOrder.cancelApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		onHidden() {
			// this.getPurchaseOrders();
		},
		addRowDataPurchaseOrderDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.purchaseOrderId = this.modelId;
					PurchaseOrderDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPurchaseOrderDetails(true);
							this.isShowPopupPurchaseOrderDetail = false;
						})
				} else {
					model.purchaseOrderId = this.modelId;
					PurchaseOrderDetail.createData(this, model)
						.then(result => {
							this.getPurchaseOrderDetails(true);
							this.isShowPopupPurchaseOrderDetail = false;
						})
				}
			}
		},
		async editRowDataPurchaseOrderDetail(id) {
			this.purchaseOrderDetailId = id;
			this.isShowPopupPurchaseOrderDetail = true;
		},
		async deleteRowDataPurchaseOrderDetail(id) {
			PurchaseOrderDetail.deleteData(this, id).then(result => { this.getPurchaseOrderDetails(); });
		},
		async resetDataPurchaseOrderDetail() {
			this.purchaseOrderDetailId = "";
			this.isShowPopupPurchaseOrderDetail = true;
		},
		async addDataPurchaseOrderDetail() {
			PurchaseOrderDetail.createData(this, { purchaseOrderId: this.modelId })
				.then(result => {
					this.getPurchaseOrderDetails(true);
				})
		},
		async addFromClipboardPurchaseOrderDetail() {
			let qtyPos = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					qtyPos.push({ qtyPo: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderDetail.addFromClipboard(this, qtyPos).then(result => { this.getPurchaseOrderDetails() });
			});
		},
		async replaceFromClipboardPurchaseOrderDetail() {
			let qtyPos = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					qtyPos.push({ qtyPo: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderDetail.replaceFromClipboard(this, qtyPos).then(result => { this.getPurchaseOrderDetails() });
			});
		},
		showPopupUploadPurchaseOrderDetail() {
			this.isShowPopupUploadPurchaseOrderDetail = true;
		},
		uploadDataPurchaseOrderDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPurchaseOrderDetail = false;
		},
		downloadPurchaseOrderDetail(modalEvent) {
			this.isDownloadPurchaseOrderDetail = true;
			this.filterPurchaseOrderDetail.purchaseOrderId = this.modelId;
			PurchaseOrderDetail.downloadDataDetail(this, this.filterPurchaseOrderDetail).then(result => {
				this.isDownloadPurchaseOrderDetail = false;
			}).catch(error => { this.isDownloadPurchaseOrderDetail = false; })
		},
		saveInputPurchaseOrderDetail(item) {
			PurchaseOrderDetail.updateDataDetail(this, item, item.id);
		},

		resetModal(modalType) {
			this.isShowPopupUploadPurchaseOrderDetail = false;
			this.isShowPopupPurchaseOrderDetail = false;
			if (modalType == 'PurchaseOrderDetail') {
				this.getPurchaseOrderDetails();
			}

			//this.showPopupCopyData = false; 
			//this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowPurchaseOrderDetailFilter = true;

			}
		},
	},
	beforeMount() {
		//this.filterPurchaseOrder = new PurchaseOrderFilter();
		//this.filterPurchaseOrder = new PurchaseOrderFilter();
		this.filterPurchaseOrderDetail = new PurchaseOrderDetailFilter();
		//this.getParts();
		//this.getPurchaseOrders();
		//this.getPurchaseRequests();
		//this.getVendors();


		//this.getPurchaseOrders();
	},
	async mounted() {
		this.isShowPopupPDF = false;
		if (this.selectedModel != null && this.selectedModel != "") {
			this.modelId = this.selectedModel.id;
			this.model = this.selectedModel;
			this.getDataDetails();
		} else if (this.selectedModelId != null && this.selectedModelId != "") {
			this.modelId = this.selectedModelId;
			this.getPurchaseOrder(this.selectedModelId);
		}
	},
	computed: {
		disableRejectRevise() {
			if (this.model.approvalRemarks == undefined || this.model.approvalRemarks == null || this.model.approvalRemarks == '') return true;
			return false;
		},
	},
	watch: {
		selectedModelId(newValue, oldValue) {
			this.isShowPopupPDF = false;
			if (newValue != oldValue) {
				this.modelId = newValue;
				this.getPurchaseOrder(newValue);
			}
		},
		selectedModel(newValue, oldValue) {
			this.isShowPopupPDF = false;
			if (newValue != oldValue) {
				this.modelId = newValue.id;
				this.model = newValue;
				this.getPurchaseOrderDetails();
			}
		},
		sortByPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		sortDescPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		currentPurchaseOrderDetailPage: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		purchaseOrderDetailPageSize: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		filterPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			},
			deep: true,
		},


	},
}
</script>
